import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.alignment},[_c('w-btn',_vm._g({staticClass:"mt-3 pl-0",attrs:{"color":"primary","disabled":_vm.disabled,"text":"","changes-form":"","min-width":"100px","data-test-id":"add-to-list-button"}},_vm.$listeners),[_c(VIcon,{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }